/**
 * MsoolLogo Component
 * 
 * Standalone Msool logo component with standardized sizing.
 */

import { FC, memo, useMemo } from 'react';
import styled from 'styled-components';
import { IMsoolLogoProps, LogoSize } from './types';
import { LOGO_SIZES, CHANNEL_BACKGROUNDS, BORDER_RADIUS } from './constants';

// Import Msool SVG
import MsoolIcon from '@assets/svg/MsoolIcon.svg?react';

interface ILogoWrapperProps {
  $size: number;
  $rounded: boolean;
}

const LogoWrapper = styled.div<ILogoWrapperProps>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  background: ${CHANNEL_BACKGROUNDS.msool};
  border-radius: ${(props) => props.$rounded ? BORDER_RADIUS.rounded : BORDER_RADIUS.default};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: ${(props) => props.$size * 0.53}px;
    height: ${(props) => props.$size * 0.53}px;
  }
`;

/** Get numeric size from LogoSize or number */
const getSize = (size: LogoSize | number): number => {
  if (typeof size === 'number') return size;
  return LOGO_SIZES[size];
};

const MsoolLogo: FC<IMsoolLogoProps> = memo(({
  size = 'xl',
  rounded = false,
  className,
}) => {
  const numericSize = useMemo(() => getSize(size), [size]);

  return (
    <LogoWrapper
      $size={numericSize}
      $rounded={rounded}
      className={className}
    >
      <MsoolIcon />
    </LogoWrapper>
  );
});

MsoolLogo.displayName = 'MsoolLogo';

export default MsoolLogo;
